// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"559":"58707877","768":"c47df302","791":"7f5b7d27","803":"5d28134c","960":"97d33c5e"}[chunkId] + ".js";
};